import {
  DashboardIcon,
  GroupUserIcon,
  EmailIcon,
  ReportIcon,
  GrapLineIcon,
  SettingsIcon,
  AutoPayIcon,
  BookIcon,
  AffiliatesIcon,
  VerticalChartIcon,
} from '@features/ui/icons';
import { PercentIcon } from 'lucide-react';
import { canAccess } from '@src/utils/auth';
import { UserRolePermission } from '@src/types/settings';
import { AuthUser } from '@src/types';

import { type SidebarData } from '../types';

export const getAdminSidebarData = (
  permissions?: AuthUser['permissions']
): SidebarData => ({
  navItems: [
    {
      icon: DashboardIcon,
      title: 'dashboardMenuItems.dashboard',
      url: '/admin/dashboard',
    },
    {
      icon: AffiliatesIcon,
      title: 'dashboardMenuItems.status',
      url: '/admin/status',
    },
    {
      icon: GroupUserIcon,
      title: 'dashboardMenuItems.tradingUsers',
      url: '/admin/users',
    },
    {
      icon: GroupUserIcon,
      title: 'dashboardMenuItems.users',
      url: '/admin/browse-users',
    },
    {
      icon: GroupUserIcon,
      title: 'dashboardMenuItems.userDemographics',
      url: '/admin/user-demographics',
    },
    {
      icon: EmailIcon,
      title: 'dashboardMenuItems.abandonedCart',
      url: '/admin/abandoned-cart',
    },
    // {
    //   icon: EmailIcon,
    //   title: 'dashboardMenuItems.emails',
    //   url: '/admin/emails',
    // },
    {
      icon: ReportIcon,
      title: 'dashboardMenuItems.reports',
      url: '/admin/reports',
      disabled: !canAccess(UserRolePermission.VIEW_REPORTS, permissions),
    },
    {
      icon: AutoPayIcon,
      title: 'dashboardMenuItems.payoutRequest',
      url: '/admin/payout-request',
    },
    {
      icon: GrapLineIcon,
      title: 'dashboardMenuItems.instruments',
      url: '/admin/instruments',
      disabled: true,
    },
    {
      icon: GrapLineIcon,
      title: 'dashboardMenuItems.productsAddons',
      url: '/admin/products-addons',
    },
    {
      icon: PercentIcon,
      title: 'dashboardMenuItems.taxAndFee',
      url: '/admin/fee-settings',
    },
    {
      icon: BookIcon,
      title: 'dashboardMenuItems.knowledgeBase',
      url: '/admin/knowledge-base',
    },
    {
      icon: PercentIcon,
      title: 'dashboardMenuItems.coupon',
      url: '/admin/coupons',
    },
    {
      icon: VerticalChartIcon,
      title: 'dashboardMenuItems.tradingPlatforms',
      url: '/admin/trading-platforms',
    },
    {
      title: 'dashboardMenuItems.termsAndConditions',
      url: '/admin/terms-and-conditions',
    },
    {
      icon: SettingsIcon,
      title: 'dashboardMenuItems.settings',
      url: '/admin/settings',
      disabled: !canAccess(
        UserRolePermission.MANAGE_SYSTEM_SETTINGS,
        permissions
      ),
    },
    {
      icon: SettingsIcon,
      title: 'dashboardMenuItems.systemSettings',
      url: '/admin/mint-settings',
      disabled: !canAccess(
        UserRolePermission.MANAGE_SYSTEM_SETTINGS,
        permissions
      ),
    },
  ],
});
